<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <cash-register-form ref="form" v-model="form" :input-errors="inputErrors" @save="update" />
  </crud-update>
</template>

<script>
import CashRegisterProvider from "../../../../providers/CashRegisterProvider";
import {CrudUpdate, ClientError} from '@dracul/common-frontend'
import CashRegisterForm from "../../../../forms/CashRegisterForm";

export default {
  name: "CashRegisterUpdate",
  components: { CashRegisterForm, CrudUpdate },
  props:{
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },
  data() {
    return {
      title: 'delivery.cashRegister.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        name: this.item.name,
        users: this.item.users.map(user => user.id),
        active: this.item.active
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        CashRegisterProvider.updateCashRegister(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateCashRegister)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }
    }
  },
}
</script>
